<section id="wrapper" class="login-register login-sidebar">
  <div class="centrar"></div>
  <div class="centrar row">
    <img
      src="assets/images/LogoIntro.png"
      style=" margin-left: auto; width: 85%; margin-right: auto; display: block;"
      class="col-12"
    />
    <div *ngIf="!activeDirectory" class="col-12">
      <form [formGroup]="signinForm" (ngSubmit)="loginUser()">
        <a href="javascript:void(0)" class="text-center db"></a>
        <div class="inputWithIcon">
          <input
            class="input"
            style="border-radius: 30px; border: none; height: 47px"
            type="text"
            placeholder="Nombre de usuario"
            formControlName="username"
          />
          <i><img src="assets/images/LoginUser2.png" alt="" /></i>
        </div>

        <div class="inputWithIcon">
          <input
            class="input"
            style="border-radius: 30px; border: none; height: 47px"
            type="password"
            placeholder="Contraseña"
            formControlName="password"
          />
          <i><img src="assets/images/LoginPassword.png" alt="" /></i>
        </div>

        <div class="form-group text-center m-t-20">
          <div class="col-xs-12">
            <button
              class="btn btn-lg btn-block text-uppercase btn-rounded background-button"
              type="submit"
            >
              Ingresar
            </button>
          </div>
          <div class="form-group text-center m-t-20">
            <div class="col-xs-12">
              <button
                class="btn btn-lg btn-block text-uppercase btn-rounded background-button"
                (click)="activeDirectoryChange()"
              >
                Active Directory
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div *ngIf="activeDirectory" class="col-12">
      <form [formGroup]="activeDirectoryForm">
        <a href="javascript:void(0)" class="text-center db"></a>
        <div class="inputWithIcon">
          <input
            style="border-radius: 30px; border: none; height: 47px"
            type="text"
            required=""
            placeholder="Ingrese su Usuario de AD"
            formControlName="username"
          />
          <i><img src="assets/images/LoginUser2.png" alt="" /></i>
        </div>
        <div class="inputWithIcon">
          <input
            style="border-radius: 30px; border: none; height: 47px"
            type="password"
            required=""
            placeholder="Ingrese su Clave de AD"
            formControlName="password"
          />
          <i><img src="assets/images/LoginPassword.png" alt="" /></i>
        </div>

        <div class="form-group text-center m-t-20">
          <div class="col-xs-12">
            <button
              class="btn btn-lg btn-block text-uppercase btn-rounded background-button"
              (click)="loginActive()"
            >
              Ingresar
            </button>
          </div>
          <div class="form-group text-center m-t-20">
            <div class="col-xs-12">
              <button
                class="btn btn-lg btn-block text-uppercase btn-rounded background-button"
                (click)="activeDirectoryChange()"
              >
                Inicio Normal
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
